const Team = (props) => {
  return (
    <section id="team-footer-background">
      <div className="OUR-TEAM">
        <h3 className="grim-title" style={{ marginBottom: "-10%" }}>
          OUR TEAM
        </h3>{" "}
        <img src="./image/team.png" alt="" style={{ width: "100%" }} />
      </div>
    </section>
  );
};

export default Team;
